import { useI18n, LANGUAGES, I18N_ENABLED } from "@/context/I18nContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Languages } from "lucide-react";

export function LanguageSelect({ testid = "language-select" }) {
  const { lang, changeLang } = useI18n();
  if (!I18N_ENABLED) return null;
  return (
    <Select value={lang} onValueChange={changeLang}>
      <SelectTrigger className="w-auto gap-2 bg-card border-border h-9 px-3" data-testid={testid}>
        <Languages size={15} className="text-primary" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-popover border-border">
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
            {l.flag} {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
